import {Component, prop, watch} from 'vue-property-decorator';

@Component({
    template: require('./save.html'),
    components: {

    }
})
export class Save {
    @prop(Object)
    state;

    close(e) {
        if(!$(e.target).closest('.popup').length) {
            this.$emit('close');
        }
    }

    save(e) {
        this.$emit('save', this.state.title);
        e.preventDefault();
        return false;
    }

    savenew() {
        this.$emit('savenew', this.state.title);
        return false;
    }
}
